import React, { useEffect, useState } from 'react';
import { db } from '../../services/firebase';
import { collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { VerisureRepair } from '../../types';

export const CriticalAlertTicker: React.FC = () => {
  const navigate = useNavigate();
  const [recentRepairs, setRecentRepairs] = useState<VerisureRepair[]>([]);

  useEffect(() => {
    // Real-time listener for the latest completed repair
    const q = query(
      collection(db, 'verisure_repairs'),
      orderBy('createdAt', 'desc'),
      limit(1)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const repairs: VerisureRepair[] = snapshot.docs.map((doc) => ({ id: doc.id, ...(doc.data() as any) }));
      setRecentRepairs(repairs);
    });

    return () => unsubscribe();
  }, []);

  if (recentRepairs.length === 0) {
    return null; // Don't show ticker if there are no repairs logged yet
  }

  const latestRepair = recentRepairs[0];

  return (
    <div className="no-print bg-gradient-to-r from-red-600 via-orange-500 to-amber-500 text-white font-sans border-b border-orange-600 shadow-xl relative z-40">
      <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2 overflow-hidden text-xs sm:text-sm">
          <span className="bg-white text-orange-600 font-extrabold px-2.5 py-0.5 rounded-full uppercase tracking-wider text-[10px] shrink-0 shadow-sm inline-flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
            VERIFIED REPAIR
          </span>
          <span className="font-bold truncate">
            {latestRepair.technicianName} logged a repair on Item ID: {latestRepair.itemId}
          </span>
          <span className="hidden md:inline text-orange-100 font-medium">
            • Post-Repair Condition Score: {latestRepair.conditionScore}/100
          </span>
        </div>

        <button
          onClick={() => navigate(`/item/${latestRepair.itemId}`)}
          className="bg-black/30 hover:bg-black/50 text-white font-bold text-xs px-3 py-1 rounded-full border border-white/30 shrink-0 transition"
        >
          View Ledger &rarr;
        </button>
      </div>
    </div>
  );
};
